// Config utilities for parsing environment variables

/**
 * Helper function to parse comma-separated lists from environment variables
 *
 * Example: `"1,2,3"` -> `["1", "2", "3"]`
 */
export const parseCsvLine = (
  envVar: string | undefined,
  fallback = ""
): string[] =>
  (envVar || fallback)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

/**
 * Combines product-specific ineligible states with US excluded territories.
 * All medical plans are not available in US territories, so this helper
 * automatically adds territories to product-specific state restrictions.
 */
export const combineWithTerritories = (
  productStates: string[],
  territories: string[]
): string[] => {
  return [...productStates, ...territories];
};
